


















import { Vue, Component, Prop } from "vue-property-decorator";

@Component({ components: {} })
export default class CCheckbox extends Vue {
  @Prop({ default: false }) disabled!: boolean;
  @Prop({ default: false }) value!: boolean;
  @Prop({ default: false }) isSwitch!: boolean;
}
